import { ComponentChildren } from 'preact'

interface SelectWrapperProps {
  children: ComponentChildren
}

function SelectWrapper({ children }: SelectWrapperProps) {
  return (
    <div className="js-form-item form-item js-form-type-select form-type-select">
      <div className="control__input control__select js-control-select is-initialized">
        {children}
      </div>
    </div>
  )
}

export default SelectWrapper
